import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSPicRegraService from '@/services/Cadastros/ApoioVendas/SLSPicRegra.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSPicRegraService = new SLSPicRegraService();
  const refPicRegraListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'tipopicid', label: 'Tipo pic', sortable: false },
    { key: 'regrapiccliente', label: 'Cliente', sortable: true },
    { key: 'regrapicrede', label: 'Rede', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalPicRegra = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref(null);
  const sortBy = ref('tipopicid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);
  const idEdit = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refPicRegraListTable.value ? refPicRegraListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPicRegra.value,
    };
  });

  const refetchData = () => {
    refPicRegraListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchPicRegra = (ctx, callback) => {
    overlay.value = true;
    sLSPicRegraService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalPicRegra.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      await sLSPicRegraService.store(body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Pic Regra cadastrada com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      let errorMessage = 'Erro ao cadastrar Pic Regra.';

      if (error.response && error.response.data) {
        const { data } = error.response;
        errorMessage = data.message || errorMessage;
      }

      console.error(errorMessage);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: errorMessage,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      });
    }
  };
  const Updated = async (idEdit, body) => {
    await sLSPicRegraService.update(idEdit, body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSPicRegraService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchPicRegra,
    tableColumns,
    perPage,
    currentPage,
    totalPicRegra,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    overlay,
    refPicRegraListTable,
    idEdit,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,
    // Extra Filters
    statusFilter,
    removerData,
  };
}
